import { ImageWidget } from "~/types/widgets";
import Image from "~/components/ui/Image";

interface Props {
  title?: string;
  socialMediaIcons?: SocialMediaIcon[];
}

export interface SocialMediaIcon {
  image: ImageWidget;
  name?: string;
  link?: string;
  width?: number;
  height?: number;
}

function Social({ title, socialMediaIcons }: Props) {
  return (
    <div className="flex flex-col">
      {title && (
        <h3 className="text-sm text-[#333333] mt-5 mb-2.5 font-bold whitespace-nowrap">
          {title}
        </h3>
      )}
      {socialMediaIcons && socialMediaIcons.length
        ? (
          <ul className="flex flex-row items-center justify-center flex-wrap xl:justify-start">
            {socialMediaIcons.map((socialMediaIcon) => {
              return (
                <li
                  className="py-1.5 mx-[12.5px] xl:ml-0 xl:mr-4"
                  title={socialMediaIcon.name}
                >
                  <a
                    href={socialMediaIcon.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Image
                      loading="lazy"
                      fetchPriority="low"
                      width={socialMediaIcon.width ?? 24}
                      height={socialMediaIcon.height ?? 24}
                      src={socialMediaIcon.image}
                      alt={socialMediaIcon.name}
                    />
                  </a>
                </li>
              );
            })}
          </ul>
        )
        : <></>}
    </div>
  );
}

export default Social;
